// extracted by mini-css-extract-plugin
export var readonly = "_ii-1";
export var star = "_ii-0";